import React, { FC, useState } from 'react'
import Checkbox from '../../UI/Inputs/Checkbox'
import SearchableInput from '../../UI/Inputs/SearchableInput'
import { makeColorDarkIfItWhite } from '../helpers'

import './Filters.scss'

type CaledarFiltersData = {
  filters: any
  setFilters: any
  clearFilters: any
}

const CaledarFilters: FC<CaledarFiltersData> = ({ filters, setFilters, clearFilters }) => {
  const [searchTerm, setSearchTerm] = useState('')
  return (
    <div className='calendar-filters'>
      <div className='calendar-filters__header'>
        <div className='calendar-filters__header__title'>Filter by</div>
        <div onClick={clearFilters} className='calendar-filters__header__clear-all'>
          Clear all
        </div>
      </div>
      <div className='calendar-filters__scroll-wrapper'>
        {Object.entries(filters).map(
          ([type, filters]: any) =>
            !!filters.length && (
              <div key={type} className='calendar-filters__by-entity'>
                <div className='calendar-filters__by-entity__title'>
                  {type.replaceAll('_', ' ')}
                </div>
                {type === 'label' && (
                  <SearchableInput
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    labels={filters}
                  />
                )}
                {filters.map(
                  (filter: any) =>
                    (type !== 'label' || filter.name.match(searchTerm)) && (
                      <div
                        key={filter.id}
                        className={`calendar-filters__by-entity__item ${
                          filter.checked && 'active'
                        }`}
                      >
                        <Checkbox
                          type='checkbox'
                          labelColor={makeColorDarkIfItWhite(filter.labelColor)}
                          checked={filter.checked}
                          label={filter.name}
                          onChange={() => setFilters({ type, id: filter.id })}
                        />
                      </div>
                    )
                )}
              </div>
            )
        )}
      </div>
      <div className='drag-filter'>
        <p>FILTER MENU</p>
      </div>
    </div>
  )
}

export default CaledarFilters
